import React from 'react';

type Props = {
  display: boolean,
}

const Loader = (props: Props): React.ReactElement => {
  const { display } = props;
  let classes = 'loader-wrapper';
  if (!display) {
    classes += ' d-none';
  }

  return (
    <div className={classes}>
      <div className="loader" />
    </div>
  );
};

export default Loader;
